import { atom } from '@reatom/framework'

import { walletsModelAtom } from '@root/entities/wallet/atoms'

import type { WalletId } from '@root/entities/wallet'

// TODO: Remove after finalizing swap confirm screens
const activeWalletDetailsIdAtom = atom<WalletId | undefined>(
  undefined,
  'activeWalletDetailsIdAtom',
)
export const activeWalletDetailsAtom = atom((ctx) => {
  const id = ctx.spy(activeWalletDetailsIdAtom)
  if (!id) {
    return undefined
  }
  const model = ctx.spy(walletsModelAtom)
  const byId = ctx.spy(model.walletsById)

  return byId.get(id)
}, 'activeWalletDetailsAtom')

export const assetsDrawerOpenAtom = atom(false, 'assetsDrawerOpenAtom')
